import Vue from 'vue';
// 格式化时间
export const dateFormat = date => {
  if (!date) return 'e';
  const dt = new Date(date * 1000);
  let y = dt.getFullYear(),
    m = dt.getMonth() + 1,
    d = dt.getDate(),
    h = dt.getHours(),
    mm = dt.getMinutes(),
    ss = dt.getSeconds();

  m = String(m).padStart(2, '0')
  d = String(d).padStart(2, '0')
  h = String(h).padStart(2, '0')
  mm = String(mm).padStart(2, '0')
  ss = String(ss).padStart(2, '0')

  return y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + ss;
}
export const dateFormatSimple = date => {
  if (!date) return 'e';
  const dt = new Date(date * 1000);
  let y = dt.getFullYear(),
    m = dt.getMonth() + 1,
    d = dt.getDate(),
    h = dt.getHours(),
    mm = dt.getMinutes(),
    ss = dt.getSeconds();

  m = String(m).padStart(2, '0')
  d = String(d).padStart(2, '0')
  h = String(h).padStart(2, '0')
  mm = String(mm).padStart(2, '0')
  ss = String(ss).padStart(2, '0')

  return y + '-' + m + '-' + d
}
export const dateFormatEn = date =>{
  if (!date) return 'e';  
  const dt = new Date(date * 1000);  
    
  const year = dt.getFullYear();  
  const month = dt.getMonth();  
  const day = dt.getDate();  
    
  // 月份缩写映射数组  
  const monthAbbreviations = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];  
  // 获取月份缩写  
  const monthAbbrev = monthAbbreviations[month];  
  // 使用 padStart 确保日期为两位数  
  const formattedDay = String(day).padStart(2, '0');  
  // 返回格式为 "DD MMM. YYYY" 的日期字符串  
  return `${formattedDay} ${monthAbbrev}. ${year}`;  
}
/** 已编辑时间，秒级时间戳，样式如 19 Aug. 2026, 10:18 AM */
export const dateFormatEdited = date => {
  if (!date) return ''
  const dt = new Date(date * 1000)
  let hours = dt.getHours()
  const minutes = String(dt.getMinutes()).padStart(2, '0')
  const suffix = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12 || 12
  return `${dateFormatEn(date)}, ${hours}:${minutes} ${suffix}`
}
export const dateFormatNews = date =>{
  if (!date) return 'e';  
  const dt = new Date(date * 1000);  
    
  const year = dt.getFullYear();  
  const month = dt.getMonth();  
  const day = dt.getDate();  
  let h = dt.getHours(),
    mm = dt.getMinutes(),
    ss = dt.getSeconds();
  h = String(h).padStart(2, '0')
  mm = String(mm).padStart(2, '0')
  ss = String(ss).padStart(2, '0') 
  // 月份缩写映射数组  
  const monthAbbreviations = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];  
  // 获取月份缩写  
  const monthAbbrev = monthAbbreviations[month];  
  // 使用 padStart 确保日期为两位数  
  const formattedDay = String(day).padStart(2, '0');  
  // 返回格式为 "DD MMM. YYYY" 的日期字符串  
  return `${h}:${mm}:${ss}  ${formattedDay} ${monthAbbrev}. ${year}`;  
}
// 图片转为base64格式
export const imageToBase64 = (img) => {
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, img.width, img.height);
  var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
  var dataURL = canvas.toDataURL("image/jpeg" + ext);
  console.log(dataURL + 'base64')
  return dataURL;
};
// base64格式转为File文件类型
// export const base64ToFile = (urlData, fileName) => {
//   let arr = urlData.split(',');
//   let mime = arr[0].match(/:(.*?);/)[1];
//   let bytes = atob(arr[1]); // 解码base64
//   let n = bytes.length
//   let ia = new Uint8Array(n);
//   while (n--) {
//       ia[n] = bytes.charCodeAt(n);
//   }
//   return new File([ia], fileName, { type: mime });
// }



export const base64ToFile = (dataurl, filename = 'file') => {
  //base64转file
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let suffix = mime.split('/')[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], `${filename}.${suffix}`, {
    type: mime
  })
}
